const PERMISSIONS = {
  DEFAULT: 'default',
  DENIED: 'denied',
  GRANTED: 'granted',
  PROMPT: 'prompt',
};

export default PERMISSIONS;
